/**
 * Subfooter actions.
 * @module actions/getSubFooter
 *  * CUSTOMIZATIONS:
 * - accept base url parameter to make requests
 *   on different urls
 */
export const GET_SUBFOOTER = 'GET_SUBFOOTER';

/**
 * Get SubFooter.
 * @function getSubFooter
 * @returns {Object} Get subfooter action.
 * Es: http://localhost:8080/Plone/@subfooter
 */
export function getSubFooter(basePath) {
  return {
    type: GET_SUBFOOTER,
    request: {
      op: 'get',
      path: `${basePath}/@subfooter`,
    },
  };
}
